{
  "page": { "title": "Inventory DIFF", "subtitle": "{{count}} SKUs reconciled" },
  "column": {
    "sku": "SKU",
    "expect": "Expect",
    "real": "Real",
    "diff": "Diff",
    "pct": "%",
    "trend": "30-day trend",
    "created": "Snapshot"
  },
  "tooltip": {
    "expect": "Quantity counted by the warehouse in its latest report.",
    "real": "Quantity recorded in Atlas at the moment that report arrived.",
    "snapshot": "The time this SKU's shelf count was reported, not when the 06:00 job ran."
  },
  "kpi": {
    "skus_checked": "SKUs checked",
    "over_threshold": "Over threshold",
    "threshold": "Threshold",
    "threshold_value": "{{pct}} % / {{pcs}} pcs",
    "alert": "Telegram alert"
  },
  "freshness": {
    "source_request": "source: {{source}} {{time}} (request {{id}})"
  },
  "alert": { "sent": "⚠ Alert", "none": "—" },
  "state": {
    "empty": "No reconciliation snapshots.",
    "error": "Could not load the inventory diff report.",
    "none": "—",
    "growing": "growing"
  },
  "toolbar": {
    "search_placeholder": "Search SKU…",
    "export": "Export",
    "over_only": "Only over threshold"
  },
  "drawer": {
    "title": "{{sku}} — report history",
    "subtitle": "Last {{count}} shelf counts, newest first",
    "reported_at": "Report time",
    "empty": "No shelf counts recorded for this SKU yet.",
    "error": "Could not load this SKU's report history."
  }
}
